/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pt-cascader-menu.vue?vue&type=template&id=73109976&scoped=true&"
import script from "./pt-cascader-menu.vue?vue&type=script&lang=ts&"
export * from "./pt-cascader-menu.vue?vue&type=script&lang=ts&"
import style0 from "./pt-cascader-menu.vue?vue&type=style&index=0&id=73109976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73109976",
  null
  
)

export default component.exports